import { S } from '../components/styles';
import Stars from '../components/Stars';

const fmtDateShort = d => new Date(d).toLocaleDateString('en-US',{month:'short',day:'numeric',year:'numeric'});
function avgRating(dish) {
  const rs = dish.dish_ratings || [];
  return rs.length ? rs.reduce((a,r)=>a+r.rating,0)/rs.length : 0;
}
const AVATAR_COLORS = ['#C4612A','#5D4037','#1A237E','#1B5E20','#BF360C','#4A148C'];
function Avatar({ name, id, size=42 }) {
  const initials = name?.split(' ').map(w=>w[0]).join('').toUpperCase()||'?';
  const bg = AVATAR_COLORS[(id||'').charCodeAt(0)%AVATAR_COLORS.length]||'#C4612A';
  return <div style={{width:size,height:size,borderRadius:'50%',background:bg,display:'flex',alignItems:'center',justifyContent:'center',color:'white',fontSize:size*.36,fontWeight:500,flexShrink:0}}>{initials}</div>;
}

export default function GreatestHits({ events }) {
  const past = events.filter(e => e.status === 'past');
  const allDishes = past.flatMap(ev =>
    (ev.dishes||[]).filter(d=>d.status==='approved'&&(d.dish_ratings||[]).length>0)
      .map(d=>({...d, eventTitle:ev.title, eventDate:ev.date}))
  );
  const sorted = [...allDishes].sort((a,b)=>avgRating(b)-avgRating(a));

  // Build guest stats from all event guests
  const guestMap = {};
  past.forEach(ev => {
    const allPeople = [{ id:ev.host_id, name:ev.profiles?.full_name, skills:[], dietary:[] },
      ...(ev.event_guests||[]).map(g=>({ id:g.user_id, name:g.profiles?.full_name, skills:g.profiles?.skills||[], dietary:g.profiles?.dietary||[] }))];
    allPeople.forEach(p => { if (!guestMap[p.id]) guestMap[p.id] = { ...p, dishes:[] }; });
    (ev.dishes||[]).filter(d=>d.status==='approved'&&(d.dish_ratings||[]).length>0).forEach(d => {
      if (guestMap[d.guest_id]) guestMap[d.guest_id].dishes.push({...d,eventTitle:ev.title});
    });
  });
  const guests = Object.values(guestMap).filter(g=>g.dishes.length>0).map(g=>({
    ...g,
    avg: g.dishes.reduce((a,d)=>a+avgRating(d),0)/g.dishes.length,
    best: [...g.dishes].sort((a,b)=>avgRating(b)-avgRating(a))[0],
  })).sort((a,b)=>b.avg-a.avg);

  return (
    <div>
      <div style={S.pageHero}><h2 style={S.h2}>Greatest Hits</h2><p style={S.textMuted}>The most beloved dishes across all your gatherings</p></div>
      <div style={S.content}>
        {sorted.length===0 && (
          <div style={S.empty}><div style={{fontSize:52,marginBottom:16}}>🌟</div><h3 style={{fontFamily:'Cormorant Garamond,serif',fontSize:24,marginBottom:8}}>No ratings yet</h3><p style={{color:'#7A6555',fontSize:14,maxWidth:280,margin:'0 auto'}}>After your first dinner party, the best dishes will be celebrated here.</p></div>
        )}

        {sorted.length>0 && (
          <>
            <h3 style={{...S.h3,marginBottom:14}}>All-time top dishes</h3>
            <div style={{display:'flex',flexDirection:'column',gap:10,marginBottom:32}}>
              {sorted.slice(0,10).map((d,i)=>{
                const a = avgRating(d);
                return (
                  <div key={d.id+i} style={{...S.card,...S.cardPad,display:'flex',alignItems:'center',gap:12}}>
                    <span style={{fontSize:20,width:28,textAlign:'center'}}>{['🥇','🥈','🥉'][i]||`${i+1}`}</span>
                    <div style={{flex:1}}>
                      <p style={{fontWeight:500}}>{d.name}</p>
                      <p style={{fontSize:11,color:'#7A6555'}}>{d.profiles?.full_name} · {d.eventTitle} · {fmtDateShort(d.eventDate)}</p>
                    </div>
                    <div style={{textAlign:'right'}}>
                      <Stars value={Math.round(a)} readonly size={14}/>
                      <p style={{fontSize:11,color:'#7A6555'}}>{a.toFixed(1)} avg</p>
                    </div>
                  </div>
                );
              })}
            </div>

            <h3 style={{...S.h3,marginBottom:14}}>Guest profiles</h3>
            <div style={{display:'flex',flexDirection:'column',gap:12}}>
              {guests.map(g=>(
                <div key={g.id} style={{...S.card,...S.cardPad}}>
                  <div style={{display:'flex',gap:12,marginBottom:12}}>
                    <Avatar name={g.name||'?'} id={g.id} size={44}/>
                    <div style={{flex:1}}>
                      <p style={{fontWeight:500}}>{g.name}</p>
                      <div style={{display:'flex',gap:12,marginTop:6}}>
                        <span style={{fontSize:13,color:'#7A6555'}}>🍽️ {g.dishes.length} dishes</span>
                        <span style={{fontSize:13,color:'#7A6555'}}>⭐ {g.avg.toFixed(1)} avg rating</span>
                      </div>
                      {g.skills?.length>0 && <p style={{fontSize:11,color:'#7A6555',marginTop:4}}>{g.skills.join(' · ')}</p>}
                    </div>
                  </div>
                  {g.best && (
                    <div style={{display:'flex',alignItems:'center',gap:12,padding:'12px 14px',background:'#FDF6E3',borderRadius:10,border:'1px solid rgba(212,160,23,.2)'}}>
                      <span style={{fontSize:20}}>👑</span>
                      <div>
                        <p style={{fontSize:11,color:'#7A6555'}}>Greatest hit</p>
                        <p style={{fontSize:13,fontWeight:500}}>{g.best.name}</p>
                        <p style={{fontSize:11,color:'#7A6555'}}>{avgRating(g.best).toFixed(1)} ★ · {g.best.eventTitle}</p>
                      </div>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
}
